import { render, staticRenderFns } from "./Windex.vue?vue&type=template&id=17278f97&"
import script from "./Windex.vue?vue&type=script&lang=js&"
export * from "./Windex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports